import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PrimeNG } from 'primeng/config';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'QLICKBO';
  private primeng = inject(PrimeNG);

  ngOnInit(): void {
    this.primeng.setTranslation({
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre ", "Diciembre"],
      monthNamesShort: ["En.", "Febr.", "Mzo.", "Abr.", "My.", "Jun.", "Jul.", "Agt.", "Sept.", "Oct.", "Nov.", "Dic."],
      weak: 'Débil',
      medium: 'Medio',
      strong: 'Fuerte',
      passwordPrompt: 'Utiliza una combinación de letras M/m, números',
      emptyFilterMessage: 'Sin resultados',
      emptyMessage: 'Sin resultados'
      //translations
    });
  }
}
